import { DataService } from "../../../../../app/shared/service/data.service";
import { Injectable } from '@angular/core';
import { User } from './user.model';
import { HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable()
export class LoginService {
  constructor(private dataService: DataService) { }
  listarOfficeUrl: string = 'Office/listarPorUsuario'
  listarRolUrl: string = 'role/listarPorUsuario'
  validLoginUrl: string = 'user/validLogin';
  listarRolPorAccesoUrl: string = 'role/listarPorAcceso'

  listarOffice(userName: string, rolID: number, empresaID: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("userName", userName);
    parameters = parameters.append("rolID", String(rolID));
    parameters = parameters.append("empresaID", String(empresaID));
    this.dataService.set(this.listarOfficeUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarRole(userName: string, officeID: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("userName", userName);
    parameters = parameters.append("officeID", String(officeID));
    this.dataService.set(this.listarRolUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarRolePorAcceso(userName: string, idEmpresa: number, idNivelAcceso: number, idEntidad: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("userName", userName);
    parameters = parameters.append("idEmpresa", String(idEmpresa));
    parameters = parameters.append("idNivelAcceso", String(idNivelAcceso));
    parameters = parameters.append("idEntidad", String(idEntidad));
    this.dataService.set(this.listarRolPorAccesoUrl);
    return this.dataService.execGetJson(parameters);
  }

  validateLogin(user: User): any {
    let parameters = new HttpParams();
    parameters = parameters.append("idNivelAcceso", String(user.idNivelAcceso));
    parameters = parameters.append("idEntidad", String(user.idEntidad));
    parameters = parameters.append("AplicacionID", String(user.aplicacionID));
    parameters = parameters.append("RolID", String(user.rolID));
    parameters = parameters.append("UserName", user.userName);
    parameters = parameters.append("Password", user.password);
    parameters = parameters.append("version", environment.versionAppWeb);
    parameters = parameters.append("appVersionID", String(environment.appVersionID));

    this.dataService.set(this.validLoginUrl);
    return this.dataService.execGetJson(parameters);
  }
}
